var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(_vm._s(_vm.UNVAN))]),_c('vs-divider',{staticStyle:{"margin":"0px !important"}}),_vm._v("\n  VD: "+_vm._s(_vm.VD)+" "),_c('vs-divider',{staticStyle:{"margin":"0px !important"}}),_vm._v(" Vkn:\n  "),_c('span',{staticStyle:{"color":"#ea5455"}},[_vm._v(_vm._s(_vm.VERGINO))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }